import axios from 'axios'
export default async (context, locale) => {
  const app = useNuxtApp()
  return await new Promise((resolve) => {
    axios.defaults.withCredentials = true;
    axios
      .get(`${app.$config.public.baseSharesquareApi}/strings?lang=en`)
      .then((response) => {
        resolve(response.data)
      })
  })
}
